const theme = {
    colorMain: '#4800CE',
    colorGray: '#C5C5C5',
    colorLightGray: '#E0E0E0'
}

export default theme